import util from '../../lib/util'
import { locationCity,synLoadAreams } from '@/api'

const areaTeams = synLoadAreams()
const qAreaTeamId = util.getQueryString('areaTeamId')
let currentAreaTeam = undefined
if (qAreaTeamId) {
    currentAreaTeam = areaTeams.filter(item => item.areaTeamId == qAreaTeamId)[0]
}

if(!currentAreaTeam && localStorage.getItem('currentAreaTeam')){
    try{
        currentAreaTeam = JSON.parse(localStorage.getItem('currentAreaTeam'))
    }catch(e){}
}
    

//根据城市
if (!currentAreaTeam) {
    const city = locationCity()
    console.log(city)
    currentAreaTeam = areaTeams.find(it => city.indexOf(it.city) != -1 )
    
}

//兜底
if (!currentAreaTeam) {
    currentAreaTeam = areaTeams[0]
}

localStorage.setItem('currentAreaTeam',JSON.stringify(currentAreaTeam))

export default {
    namespaced: true,
    state: {//state
        currentAreaTeam: currentAreaTeam,
        areaTeams: areaTeams
    },
    mutations: {
        setCurrentAreaTeam(state, areaTeam) {
            state.currentAreaTeam = areaTeam
            localStorage.setItem('currentAreaTeam',JSON.stringify(areaTeam))
        }
    },
    actions: {
    }
}


// WEBPACK FOOTER //
// ./src/components/store/areaTeams.js